/**
 * Sperre der geteilten Kopffelder im Einzel-Drawer (Task 7, Spec "Bestell- und Sammelsendungs-
 * Drawer"): Solange die Bestellung Mitglied einer Sendung mit mindestens zwei Mitgliedern ist,
 * werden Lieferant, Rechnungsnummer, Lager, Status und Zahlungsziel zentral in der Sammelsendung
 * gepflegt. Eigene Notizen, Positionen, Tasks, Dokumente und Raten bleiben bedienbar.
 *
 * Die Mitgliedschaft kommt ausschliesslich aus `Order.shipmentParent` (Sendungsnummer), nie aus
 * `shipmentOrderGroup`.
 */
import type { Order, ShipmentParentProjektion } from "../../lib/types.ts";

export const SAMMELSENDUNG_PFLEGEHINWEIS = "In Sammelsendung pflegen";

/** Die Sammelsendung, die die geteilten Felder dieser Bestellung sperrt, sonst `null`. */
export function sperrendeSammelsendung(bestellung: Order): ShipmentParentProjektion | null {
  const parent = bestellung.shipmentParent;
  return parent && parent.memberCount >= 2 ? parent : null;
}
